import { gql } from '@apollo/client'

// Permissions module — all fields are GenericScalar (whole objects, no subselection).

export const PERMISSION_CATALOG = gql`
  query PermissionCatalog {
    permissionCatalog
  }
`

export const ROLES = gql`
  query Roles {
    roles
  }
`

export const PERMISSION_GROUPS = gql`
  query PermissionGroups {
    permissionGroups
  }
`

// Dedicated, uniquely-named users query for the permission pickers. A unique
// operation name avoids clashing with the other `allUsers` documents (which
// caused empty option lists under cache-first).
export const PERMISSION_USERS = gql`
  query PermissionUsers($first: Int, $isActive: Boolean, $name: String) {
    allUsers(first: $first, isActive: $isActive, name: $name) {
      edges {
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const MY_PERMISSIONS = gql`
  query MyPermissions {
    myPermissions
  }
`

export const USER_PERMISSIONS = gql`
  query UserPermissions($userId: ID!) {
    userPermissions(userId: $userId)
  }
`

export const SET_USER_OVERRIDES = gql`
  mutation SetUserOverrides($userId: ID!, $allow: [String]!, $deny: [String]!) {
    setUserOverrides(userId: $userId, allow: $allow, deny: $deny) {
      success
      user
    }
  }
`

export const SET_GROUP_PERMISSIONS = gql`
  mutation SetGroupPermissions($groupId: ID!, $codenames: [String]!) {
    setGroupPermissions(groupId: $groupId, codenames: $codenames) {
      success
      group
    }
  }
`

export const BULK_ASSIGN_PERMISSIONS = gql`
  mutation BulkAssignPermissions($codenames: [String]!, $effect: String!, $targetType: String!, $targetIds: [ID]!) {
    bulkAssignPermissions(codenames: $codenames, effect: $effect, targetType: $targetType, targetIds: $targetIds) {
      success
      updated
    }
  }
`

export const CREATE_ROLE = gql`
  mutation CreateRole($name: String!) {
    createRole(name: $name) {
      success
      role
    }
  }
`

export const UPDATE_ROLE = gql`
  mutation UpdateRole($roleId: ID!, $name: String!) {
    updateRole(roleId: $roleId, name: $name) {
      success
      role
    }
  }
`

export const DELETE_ROLE = gql`
  mutation DeleteRole($roleId: ID!) {
    deleteRole(roleId: $roleId) {
      success
    }
  }
`

export const SET_ROLE_PERMISSIONS = gql`
  mutation SetRolePermissions($roleId: ID!, $codenames: [String]!) {
    setRolePermissions(roleId: $roleId, codenames: $codenames) {
      success
      role
    }
  }
`
